// extracted by mini-css-extract-plugin
export default {"linkboxes":"DeliveryInfoModal_linkboxes__iHtE1","linkbox":"DeliveryInfoModal_linkbox__vtzR4","linkTag":"DeliveryInfoModal_linkTag__bhLPJ"};